import { CONSENT_STATUS } from "./constants";

const checkUserConsent = (subscriptionStatus) => {
  if (
    subscriptionStatus === CONSENT_STATUS.OPTED_IN ||
    subscriptionStatus === CONSENT_STATUS.IMPLICIT
  ) {
    return true;
  }
  if (
    subscriptionStatus === CONSENT_STATUS.REVOKED ||
    subscriptionStatus === CONSENT_STATUS.REQUESTED
  ) {
    return false;
  } else return false;
};

export default checkUserConsent;
